var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Root',[_c('NavBar',{attrs:{"sectionElements":this.subSections}}),_c('Title',[_vm._v(_vm._s(this.title))]),_c('TextSection',[_vm._t("default")],2),_c('FixedBox',{attrs:{"sourceCode":this.sourceCode}}),_c('br'),_c('br')],1)}
var staticRenderFns = []

export { render, staticRenderFns }